import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Dep } from '../class/auth';
import { menulist } from '../class/status';
import { Rtable } from '../class/rtabledata';
import { page } from '../../comm/class/status';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rewardoffical',
  templateUrl: './rewardoffical.component.html',
  styleUrls: ['./rewardoffical.component.css']
})
export class RewardofficalComponent implements OnInit {
  isMouseOverCarousel = false;
  @ViewChild('carousel') private carousel: ElementRef;
  target:any = {user_id:'',uid:'',phonenum:'',fixid:-1};
  trade_info:any = {to_user_id:'',to_profile_pic:'',diamond:0,trade_type:'1',search:'',list:[],cust_from:0}
  sub_list:menulist=[
    {id:'0',name:'一般操作'},
    {id:'1',name:'補用戶交易'},
  ];

  generarr = ['性別','男生','女生'];

  tcontent = [
    {title:'會員名',content:'name',type:2},
    {title:'性別',content:'gender',replaceArr:this.generarr},
    {title:'大頭貼',content:'profile_pic',type:1},
    {title:'電話',content:'phone_num'},
    {title:'操作鑽石',content:'diamond'},
    {title:'現有鑽石',content:'now_d'},
    {title:'操作',content:'gg',type:3},
 ];


  subnow:string = '0';
  now:string = '0';
  tmp_img_b64:{};
  search_model:string = '';
  reason:string = '';
  money:number = 0;
  tw:number = 0;
  search_type:string='1';
  option_list:menulist = [{id:'1',name:'外部儲值匯款'},{id:'2',name:'行銷費用'},{id:'3',name:'補發獎勵'},{id:'4',name:'其他'},{id:'5',name:'回收鑽石收益'},{id:'7',name:'活動獎勵'},{id:'8',name:'用戶回歸獎勵'},{id:'9',name:'回收鑽石收益(外部經紀)'}];
  type_list:menulist = [{id:'1',name:'文字'},{id:'2',name:'語音'},{id:'5',name:'視訊'},{id:'4',name:'解鎖'},{id:'25',name:'禮物'}];
  show:any={1:"外部儲值匯款",2:"行銷費用",3:"補發獎勵",4:"其他",5:"回收鑽石收益",6:"經濟公司提領",7:"活動獎勵",8:"用戶回歸獎勵",9:"回收鑽石收益(外部經紀)"};
  data:any=[];
  detaildata:any=[];
  check_user_info:any=[];
  search_result_staus = false;
  power:number = 0;
  loading:boolean=false;
  preurl :string = '';
  urltoken :string = '';
  urltoken2 :string = '';
  grouped_check_user_info:any=[];
  
  pageobj:page = {page:0,count:100,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }


  validateMoney() {
    if (this.money < 0) {
        this.money = 0; // 若小于 1，重置为 1
    }
  }

  ngOnInit(): void {
    this.preurl = environment.serverurl;
    
    this.power = Dep.auth.power_id;
    this.urltoken2 = this.preurl+"/export_info.php?token="+Dep.token+"&time="+Date.now();
    this.urltoken = this.preurl+"/export_info.php?limit=true&token="+Dep.token+"&time="+Date.now();
    this.init_list();
  }

  trade_btn_type(item) {
    // 定義 typels 物件，而非數組
    const typels = {
        '1': '文字',
        '2': '語音',
        '5': '視訊',
        '4': '解鎖',
        '25': '禮物'
    };

    // 根據 item 取得對應的類型文字
    this.reason = '';
    if(this.target.name != undefined && this.trade_info.name != undefined){
        this.reason = `「${this.target.name}」與「${this.trade_info.name}」補「${typels[item]}」交易`;
    }

    // 設定 trade_type
    this.trade_info.trade_type = item;
}

  callitem(item){
    this.now = '0';//還原預設值
    this.target = item;    
  }
  callitemDetail(item){
    this.target_user(item);
    this.trade_btn_type('1');      
  }

  target_user(item){
    if(item.gender!=this.target.gender){
      this.trade_info.to_user_id=item.id;
      this.trade_info.profile_pic=item.profile_pic
      this.trade_info.name=item.name
    }else{
      alert('性別要不同才能交易');
      this.trade_info.to_user_id='';
      this.trade_info.profile_pic='';
      this.trade_info.name='';
    }
    
  }

  check_user(type=0){
  
    let search = '';
    if(type==0){
      search = this.search_model;
    }else{
      search = this.trade_info.search;
    }
    if(search.trim().length>0){
      this.loading = true;
      const body = {
      search:search,  
      countT:1,  
      };
      this.httpClient.post<any>("/get_user_list.php",body).subscribe(res => {
        console.log(res)
        this.search_result_staus = true;
        this.loading = false;
        if(res.status){
          if(type==0){
            this.check_user_info = res.data;
            

            // 将用户信息按每 10 个分组成子数组
            this.grouped_check_user_info = [];
            const chunkSize = 10;
            for (let i = 0; i < this.check_user_info.length; i += chunkSize) {
              this.grouped_check_user_info.push(this.check_user_info.slice(i, i + chunkSize));
            }


          }else{
            this.trade_info.list = res.data;
          }
          
        }else{
          this.trade_info.list = [];
          this.check_user_info = [];
        }


        window.setTimeout(()=>{
          this.search_result_staus = false;
        },3000)
      });  
    }else{
        this.check_user_info=[];
        this.grouped_check_user_info=[];
    }

    this.init_list();

   
  }

  searchstr(item){
    this.search_model = item;
    this.init_list();
  }

  init_list(){
    const body = {page: this.pageobj.page,count:this.pageobj.count,token:Dep.token,
    search:this.search_model,search_type:this.search_type,action:1
    };
    this.loading = true;
    this.httpClient.post<any>("/get_offical_reward_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res)
      this.trade_info = {to_user_id:'',to_profile_pic:'',diamond:0,trade_type:'1',search:'',list:[],cust_from:0};
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  detail(){
    const body = {page:0,count:2000,token:Dep.token,
    user_id:this.target.id,action:2
    };
    this.loading = true;
    this.httpClient.post<any>("/get_offical_reward_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res)
      if(res.status){
        this.detaildata = res.data;
      }else{
        this.detaildata = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });  
  }

  alert(){
    if(this.money <= 0){
        alert('鑽石數需大於或等於1');
    }else{
        alert('請指定對象');
    }
  }

  send_it(){

    if(this.subnow=='1' && this.trade_info.to_user_id.length == '0'){
      alert('請指定對象');
    }else{
      const body = {
        user_id:this.target.id,
        subnow:this.subnow,
        trade_info:this.trade_info,
        tw:this.tw,
        diamond:this.money,
        reason:this.reason,
        search_type:this.search_type,
        type:2,
        pic:this.tmp_img_b64,
        };

  
      this.loading = true;
      this.httpClient.post<any>("/send_diamond_pro.php",body).subscribe(res => {
      this.loading = false;
      this.money = 0;
      this.tw = 0;
      this.reason = '';
      this.search_type = '1';
      this.tmp_img_b64='';
      this.target = {user_id:'',uid:'',phonenum:'',fixid:-1,name:'',phone_num:''};
      Swal.fire("已送出!", "", "success");
      this.init_list();

      });  
    }

    
  }

  adjust_pic(type){
    let status = false;
    if(type==-1){//刪除
      if(confirm('是否確定刪除')){
        status = true;
      }
    }else{
      status = true;
    }
    if(status){
      const body = {
        search_type:-1,
        type:type,
        pic:this.tmp_img_b64,
        id:this.target.fixid,
        diamond:0,
      };
      this.loading = true;
      this.httpClient.post<any>("/send_diamond_pro.php",body).subscribe(res => {
      this.loading = false;
      this.detail();
      console.log('save',res);
      });  
    }
   
  }


  upload(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.tmp_img_b64 = e.target.result;
        if(this.target.fixid!=-1){ //修改的才能直接改
          this.adjust_pic(1);
        }
       
      });
    }
  }

  up_dt(id,type,money){

    const body = {
      id:id,
      search_type:type,
      tw:money,
      type:3,
      diamond:0,
    };

    this.loading = true;
    this.httpClient.post<any>("/send_diamond_pro.php",body).subscribe(res => {
    this.loading = false;
    if(!res.status){
      alert(res.message);
    }
    console.log(res);
   });  
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

 

}
